import { createElement } from 'react';
import { StyledCenterChildren } from './styles/center-children.ccm.css';
export const CenterChildren = ({
  children,
  flexDirection = 'column'
}) => createElement(StyledCenterChildren.div, {
  $flexDirection: flexDirection
}, children);